export default __webpack_public_path__ + "static/media/photo--sm--81.8b93e68f.jpg";